<div id="body-container">
  <div class="background-blue">
    <div class="claims-page-banner container">
      <h1 style="font-size: 22.5px"><adp-label labelKey="CoverageBannerTitle"></adp-label></h1>
    </div>
  </div>
  <div><pgh-coverage [isHomeTechProductTemplate]="true"></pgh-coverage></div>
</div>




